import type { LayoutHandleProps } from 'layouts/Layout/LayoutHandleProps';
import { orgDashboardManageListingsRoute } from 'modules/orgDashboard/routing/orgDashboard.routes';
import type { HorizonAppRouteLoaderArgs } from 'routing/classes/types/AppRouteLoaderArgs';
import type { HorizonAppRouteComponentProps } from 'routing/types/HorizonAppRouteComponentProps';

import { ManageListingsPageLoadable } from './ManageListingsPageLoadable';

export const handle = {
  fallbackUrlByLocaleToCurrent: true,
  darkBackground: true,
  showDesktopSearch: true,
} satisfies LayoutHandleProps;

export async function loader(
  _: HorizonAppRouteLoaderArgs<typeof orgDashboardManageListingsRoute>,
) {
  await ManageListingsPageLoadable.load();
}

export default function OrgDashboardManageListingsHorizonRoute(
  _: HorizonAppRouteComponentProps<typeof loader>,
) {
  return <ManageListingsPageLoadable />;
}
